import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'

import NewIqacSidebar from './NewIqacSidebar'

import TypingEffect from '../TypingEffect'

function IQACNew() {
  return (
    <>
    <style>{`
        .footer_main01  { display:none;      }
      `}</style>
      <div className='new_iqac'>
         
              <div className='row'>
                  <div className='col-md-3'>

                    <NewIqacSidebar />

                        
                  </div>

                  <div className='col-md-9'>
                    <div className='home'>
                        <div className='iqacherobanner'>
                            <img src='/assets/img/iqac-banner.jpg'></img>
                            <div className='caption'>
                                 <h1>Internal Quality Assurance Cell</h1>
                                <h4>We thrive for <TypingEffect /></h4>  
                            </div>
                        </div>
                        <div className='about'>
                            <div className='row'>
                                <div className='col-md-8 col-sm-7 col-xs-12'>
                                    <div className='text'>
                                        <h3>The person who wins is the one who thinks he can.</h3>
                                        {/* <label>Modern Vidya Niketan Society: A Legacy of Excellence in Education
                                        </label> */}
                                        <p>
                                                The Internal Quality Assurance Cell (IQAC) plays a pivotal role in sustaining and enhancing the culture of quality, accountability, and innovation across all spheres of MVN University. As a central quality monitoring body, IQAC continuously strives to strengthen academic and administrative performance through structured processes, periodic reviews, and outcome-based improvements.
At MVN University, quality is not merely a benchmark — it is an ongoing journey towards excellence. The IQAC ensures that every school of the university, department(s), faculty member, and student should align with the University’s vision and mission in fostering academic integrity, professional competence, and holistic development. Through regular assessment, feedback mechanisms, and quality enhancement initiatives, the IQAC promotes best practices that enrich research, teaching & learning. <br/><br/>

In tune with the University's commitment to Outcome-Based Education (OBE) and global standards-setting at MVN University, the IQAC is actively encouraging innovation in pedagogy, curriculum design, and evaluation processes. IQAC at MVN University involves stakeholder (students, parents, alumni, and industry experts) participation to empower the University's academic environment to remain dynamic, inclusive, and future-ready.<br/><br/>

We invite you to explore, engage, and grow with MVN University, where quality education meets inspiration, and where every effort is directed toward shaping competent, responsible, and visionary professionals.




                                        </p>
                                    </div>
                                </div>
                                <div className='col-md-4 col-sm-5 col-xs-12'>
                                     <div className='cansole_mean '>
                                     <img src='/assets/img/placement/newpro-3.jpg'></img> 
                                        <h3>Prof. (Dr.) Yogendra Singh</h3>
                                        <p>Registrar & Director IQAC</p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='about'>
                            <div className='row'>
                                <div className='col-md-8 col-sm-7 col-xs-12'>
                                    <div className='text'>
                                        <h3>Upholding the Mission</h3>
                                        {/* <label>Modern Vidya Niketan Society: A Legacy of Excellence in Education
                                        </label> */}
                                        <p>At MVN University, our mission is to deliver <b>quality, inclusive, and equitable education</b> that transforms lives and empowers communities. Our commitment is
to continuous improvement in academic standards, transparency in processes, and innovation in teaching–learning practices. We strive to create an
environment where diversity is embraced, opportunities are equal, and excellence is a shared goal. Through collaborative efforts, rigorous quality checks, and
feedback-driven growth, we ensure that our institution not only meets but exceeds benchmarks and as a destination for preparing our students to be ethical
leaders and lifelong learners in a rapidly changing world.
                                        </p>
                                    </div>
                                </div>
                                <div className='col-md-4 col-sm-5 col-xs-12'>
                                     <div className='cansole_mean '>
                                     <img src='/assets/img/placement/newpro-4.jpg'></img> 
                                        <h3>Dr. Shrivardhan Dheeman</h3>
                                        <p>Dy. Director IQAC</p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* 
                        <div className='faculties'>
                            <div className='row'>
                                <div className='col-md-3 col-sm-3 col-xs-12'>
                                    <div className='detail'>
                                        <div className='icon'>
                                        <i class="fa fa-building" aria-hidden="true"></i>
                                        </div>
                                        <label>19</label>
                                        <p>Faculties</p>
                                    </div>
                                </div>
                                <div className='col-md-3 col-sm-3 col-xs-12'>
                                    <div className='detail'>
                                        <div className='icon'>
                                        <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                                        </div>
                                        <label>200+</label>
                                        <p>Programs</p>
                                    </div>
                                </div>
                                <div className='col-md-3 col-sm-3 col-xs-12'>
                                    <div className='detail'>
                                        <div className='icon'>
                                        <i class="fa fa-book" aria-hidden="true"></i>
                                        </div>
                                        <label>10000+</label>
                                        <p>Alumni</p>
                                    </div>
                                </div>
                                <div className='col-md-3 col-sm-3 col-xs-12'>
                                    <div className='detail'>
                                        <div className='icon'>
                                        <i class="fa fa-book" aria-hidden="true"></i>
                                        </div>
                                        <label>10000+</label>
                                        <p>Research Publications</p>
                                    </div>
                                </div>
                            </div>
                        </div>  */}
                    </div>
                  </div>


              </div>

         

      </div>

    </>
  )
}

export default IQACNew